export enum EnumModeResetPassword {
    Mail = 'mail',
    Sms = 'sms',
    None = 'none',
}
